import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators, compose } from 'redux';
import { withRouter } from 'react-router-dom';

import { Features } from 'utils/features';
import { selectUser } from 'entities/user/selectors';
import * as NotificationActions from 'containers/Notification/actions';
import getDeedFeatureForDeedType from 'utils/getDeedFeatureForDeedType';
import { useInjectReducer } from 'utils/injectReducer';
import { useInjectEpics } from 'utils/injectEpics';
import { Privileges, DeedManagerPrivileges } from 'utils/privileges';
import DeedsPageV2 from 'containers/DeedsPageV2';

import * as Actions from './actions';
import reducer from './reducer';
import epicsReduced from './epicsReduced';

const getDeedTypeFromRouteParam = (type) => {
  switch (type) {
    case 'campaigns':
      return 'Campaign';

    case 'projects':
      return 'Project';

    case 'volunteer':
      return 'Event';

    case 'events':
      return 'BaseEvent';

    case 'actions':
      return 'Action';

    default:
      return 'Event';
  }
};

const key = 'deedsPage';

const DeedsPage = ({ actions, match, history, user }) => {
  useInjectReducer({ key, reducer });
  useInjectEpics({ key, epics: epicsReduced });

  useEffect(() => {
    actions.initAction();
  }, [actions]);

  const routeMatchType = match.params.type;
  const deedType = getDeedTypeFromRouteParam(routeMatchType);

  useEffect(() => {
    if (
      user &&
      (!user.hasFeature(getDeedFeatureForDeedType(deedType)) ||
        !user.hasPrivilege(DeedManagerPrivileges[deedType]))
    ) {
      let redirect = '/';
      if (user.hasFeature(Features.VOLUNTEERING) && user.hasPrivilege(Privileges.EVENT_MANAGE)) {
        redirect = '/deeds/volunteer';
      } else if (
        user.hasFeature(Features.EVENTS) &&
        user.hasPrivilege(Privileges.BASE_EVENT_MANAGE)
      ) {
        redirect = '/deeds/events';
      } else if (
        user.hasFeature(Features.VOLUNTEERING) &&
        user.hasPrivilege(Privileges.PROJECT_MANAGE)
      ) {
        redirect = '/deeds/projects';
      } else if (user.canDonate() && user.hasPrivilege(Privileges.FUNDRAISER_MANAGE)) {
        redirect = '/deeds/campaigns';
      }
      history.replace(redirect);
    }
  }, [user]);

  return <DeedsPageV2 />;
};

DeedsPage.propTypes = {
  user: PropTypes.object,
  actions: PropTypes.object,
  match: PropTypes.object,
  history: PropTypes.object,
};

const withConnect = connect(
  (state) => ({
    user: selectUser(state),
  }),
  (dispatch) => ({
    actions: bindActionCreators({ ...Actions, ...NotificationActions }, dispatch),
  })
);

export default compose(withRouter, withConnect)(DeedsPage);
